import Navbar from '../navigation/Navbar';
import HireTalent from '../app/HireTalent';
import Tips from '../JobHome/Tips';
import Categories from '../app/Categories';
import Footer from '../../components/app/Footer';
import BlogHome from './BlogHome';


function BlogsPage() {

    return (
        <>
        <Navbar selected='Help'/>
        <BlogHome></BlogHome>
        <HireTalent/>
        <Tips/>
        <Categories></Categories>
        <Footer></Footer>
        </>
    );
}

export default BlogsPage;